import React, { SetStateAction } from 'react';
import { Button } from 'react-bootstrap';

import companyIcon from 'images/directory/company_icon.svg';
import locationIcon from 'images/directory/location_icon_black.svg';
import openToIcon from 'images/directory/opento_icon.svg';
import skillIcon from 'images/directory/skill_icon.svg';
import topicIcon from 'images/directory/topic_icon.svg';

import { FilterOptionsResponse } from '../../utils/backend-api/subscriber_directory';
import { FilterOption as FilterOptionType } from '../../utils/backend-api/subscriber_directory';
import { Divider } from '../BaseUI';
import { CheckBoxGroup, RadioButtonGroup } from '../FormFields';
import FilterOption from './FilterOption';
import { ShowFilterMap } from './Layout';

const LIST_DISPLAY_OPTIONS = [
  { label: 'Investor profiles', value: 'investors' },
  { label: 'CEO profiles', value: 'ceos' },
  { label: 'All subscriber profiles', value: 'all' },
];

interface FilterNavProps {
  companyOptions: FilterOptionType[];
  handleResetForm: () => void;
  locationOptions: FilterOptionType[];
  openToOptions: FilterOptionType[];
  setDisplayedFilterOptions: (option: SetStateAction<FilterOptionsResponse>) => void;
  setShowFilterMap: (showFilterMap: SetStateAction<ShowFilterMap>) => void;
  setShowSlideFilter: (showSlideFilter: boolean) => void;
  showFilterMap: ShowFilterMap;
  showSlideFilter: boolean;
  skillsOptions: FilterOptionType[];
  topicsOptions: FilterOptionType[];
}

const FilterNav = ({
  companyOptions,
  handleResetForm,
  locationOptions,
  openToOptions,
  setDisplayedFilterOptions,
  setShowFilterMap,
  setShowSlideFilter,
  showFilterMap,
  showSlideFilter,
  skillsOptions,
  topicsOptions,
}: FilterNavProps) => {
  return (
    <div className="FilterNav">
      <div className="filter-container list-display">
        <RadioButtonGroup name="listDisplay" options={LIST_DISPLAY_OPTIONS} />
      </div>
      <Divider />

      <FilterOption
        fieldName="openTo"
        icon={openToIcon}
        input={<CheckBoxGroup name="openTo" options={openToOptions} />}
        label="Open to"
        setShowFilterMap={setShowFilterMap}
        showFilter={showFilterMap['openTo']}
      />
      <FilterOption
        fieldName="company"
        filterOptions={companyOptions}
        icon={companyIcon}
        input={<RadioButtonGroup name="company" options={companyOptions} />}
        label="Company"
        optionName="companyOptions"
        searchOptions={{
          isMultiValueField: false,
          searchParams: {
            relationship_sources: ['ti_profile'],
            relationship_type: 'company_name',
          },
        }}
        setDisplayedFilterOptions={setDisplayedFilterOptions}
        setShowFilterMap={setShowFilterMap}
        showFilter={showFilterMap['company']}
      />
      <FilterOption
        fieldName="location"
        filterOptions={locationOptions}
        icon={locationIcon}
        input={<RadioButtonGroup name="location" options={locationOptions} />}
        label="Location"
        optionName="locationOptions"
        searchOptions={{
          isMultiValueField: false,
          searchParams: {
            relationship_sources: ['ti_profile'],
            relationship_type: 'location',
          },
        }}
        setDisplayedFilterOptions={setDisplayedFilterOptions}
        setShowFilterMap={setShowFilterMap}
        showFilter={showFilterMap['location']}
      />
      <FilterOption
        fieldName="skills"
        filterOptions={skillsOptions}
        icon={skillIcon}
        input={<CheckBoxGroup name="skills" options={skillsOptions} />}
        label="Skills"
        optionName="skillsOptions"
        searchOptions={{
          isMultiValueField: true,
          searchParams: {
            relationship_sources: ['ti_profile'],
            relationship_type: 'skill',
          },
        }}
        setShowFilterMap={setShowFilterMap}
        showFilter={showFilterMap['skills']}
        setDisplayedFilterOptions={setDisplayedFilterOptions}
      />
      <FilterOption
        fieldName="topics"
        filterOptions={topicsOptions}
        icon={topicIcon}
        input={<CheckBoxGroup name="topics" options={topicsOptions} />}
        label="Followed topics"
        optionName="topicsOptions"
        searchOptions={{
          isMultiValueField: true,
          searchParams: {
            relationship_sources: ['topic'],
            order_entities_by: ['is_important', 'pdl_verified'],
          },
        }}
        setDisplayedFilterOptions={setDisplayedFilterOptions}
        setShowFilterMap={setShowFilterMap}
        showFilter={showFilterMap['topics']}
      />
      <div className="clear-filter-btn-wrapper --hide-md">
        <Button className="profile-button --blue --full-width" onClick={handleResetForm}>
          Clear All Filters
        </Button>
      </div>
      <div className="mobile-filters-action">
        <Button className="profile-button --light-grey" onClick={handleResetForm}>
          Reset
        </Button>
        <Button
          className="profile-button --red"
          onClick={() => setShowSlideFilter(!showSlideFilter)}
        >
          Show Search
        </Button>
      </div>
    </div>
  );
};
export default FilterNav;
